var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAboutIcon4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_391)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1885 36.9332H21.4653",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5347 36.9332H41.8115",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_391",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H70V70H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1996 28.8586C21.3336 26.611 22.8265 24.6545 24.9867 23.945L32.1002 21.603",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8998 21.603L45.0133 23.945C47.1734 24.6545 48.6664 26.611 48.8004 28.8586",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9003 18.1509V21.6036C37.9003 23.2054 36.6018 24.5038 35 24.5038C33.3982 24.5038 32.0996 23.2054 32.0996 21.6036V18.1509",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6293 7.65459C41.6293 3.9934 38.6613 1.02538 35.0001 1.02538C31.3388 1.02538 28.3707 3.9934 28.3707 7.65459V12.074C28.3707 15.7352 31.3388 18.7032 35.0001 18.7032C38.6613 18.7032 41.6293 15.7352 41.6293 12.074V7.65459Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4271 51.3529C41.7595 49.3486 43.1758 47.6588 45.15 47.008L52.2635 44.6674",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9746 58.6182V59.9977H55.1632H48.8113",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0645 44.6674L65.1779 47.008C67.4434 47.7545 68.9746 49.8709 68.9746 52.2567V53.8281",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7366 44.6674L24.8499 47.008C26.8243 47.6588 28.2405 49.3486 28.5729 51.3529",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1888 59.9977H14.8367H1.02551V58.6182",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02539 53.8281V52.2567C1.02539 49.8709 2.55664 47.7545 4.82207 47.008L11.9355 44.6674",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0641 41.215V44.6677C58.0641 46.2695 56.7656 47.5679 55.1638 47.5679C53.562 47.5679 52.2635 46.2695 52.2635 44.6677V41.215",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.793 30.7187C61.793 27.0575 58.825 24.0895 55.1638 24.0895C51.5024 24.0895 48.5345 27.0575 48.5345 30.7187V35.1381C48.5345 38.7993 51.5026 41.7673 55.1638 41.7673C58.825 41.7673 61.793 38.7993 61.793 35.1381V30.7187Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1741 56.4068V59.9976",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7365 41.215V44.6677C17.7365 46.2695 16.4381 47.5679 14.8363 47.5679C13.2345 47.5679 11.9359 46.2695 11.9359 44.6677V41.215",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4653 30.7187C21.4653 27.0575 18.4973 24.0895 14.8363 24.0895C11.1749 24.0895 8.20691 27.0575 8.20691 30.7187V35.1381C8.20691 38.7993 11.1749 41.7673 14.8363 41.7673C18.4973 41.7673 21.4653 38.7993 21.4653 35.1381V30.7187Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82593 56.4068V59.9976",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8109 67.605V68.9746H35H21.1892V57.7805C21.1892 55.3949 22.7206 53.2788 24.9866 52.5329L32.0998 50.1919",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9004 50.1919L45.0135 52.5331C47.2796 53.2788 48.811 55.3949 48.811 57.7805V62.8175",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9003 46.7392V50.1919C37.9003 51.7937 36.6018 53.0923 35 53.0923C33.3982 53.0923 32.0996 51.7937 32.0996 50.1919V46.7392",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6293 36.243C41.6293 32.5818 38.6613 29.6138 35.0001 29.6138C31.3388 29.6138 28.3707 32.5818 28.3707 36.243V40.6624C28.3707 44.3236 31.3388 47.2916 35.0001 47.2916C38.6613 47.2916 41.6293 44.3236 41.6293 40.6624V36.243Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0104 61.9311V68.9746",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9896 61.9311V68.9746",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAboutIcon4);
export default __webpack_public_path__ + "static/media/home-about-icon-4.1caf999c9a99c49ed9508074e41cc725.svg";
export { ForwardRef as ReactComponent };